var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-button',{staticClass:"app-progress-button",attrs:{"is-disabled":_vm.isDisabled || _vm.inProgress},on:{"click":_vm.click}},[(_vm.inProgress)?_c('span',{staticClass:"app-progress-button__inner"},[_c('app-loader'),_vm._v("\n    "+_vm._s(_vm.progressText)+"\n  ")],1):_c('span',[_vm._v(_vm._s(_vm.buttonText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }